import { Component, Input, OnInit } from '@angular/core';
import { CoraState } from 'src/app/shared/shared.module';

@Component({
  selector: 'hour4u-admin-agent-thinking-ui',
  templateUrl: './agent-thinking-ui.component.html',
  styleUrls: ['./agent-thinking-ui.component.scss']
})
export class AgentThinkingUiComponent implements OnInit {
  @Input() totalParsedLeads: number = 0;
  @Input() shortlistedText: string = 'Cora has shortlisted the candidates';
  @Input() completedText: string = 'Cora has shortlisted the candidates.';
  @Input() tickIconUrl: string = 'assets/tick-circle.svg';
  @Input() loaderColor: string = 'accent';
  @Input() coraState: CoraState = null;

  constructor() { }

  ngOnInit() {
  }

}
